import makeStyles from '@material-ui/core/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: '20px'
  }
}))
